import { render, staticRenderFns } from "./ProjectBigMap.vue?vue&type=template&id=f76160c4&scoped=true"
import script from "./ProjectBigMap.vue?vue&type=script&lang=ts"
export * from "./ProjectBigMap.vue?vue&type=script&lang=ts"
import style0 from "./ProjectBigMap.vue?vue&type=style&index=0&id=f76160c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76160c4",
  null
  
)

export default component.exports